module.exports = __webpack_public_path__ + "img/SliderCutImg3.3df2603f.jpg";